import './App.css';
import WebsiteUnderUpdate from './components/WebsiteUnderUpdate';

function App() {
  return <WebsiteUnderUpdate />;
}


export default App;
